export function blockScroll() {
  const scrollWidth = getScrollWidth();
  document.documentElement.style.overflowY = 'hidden'
  document.documentElement.style.paddingRight = scrollWidth + 'px'
  document.documentElement.classList.add('_scroll-lock')
}

export function unBlockScroll() {
  document.documentElement.style.overflowY = null
  document.documentElement.style.paddingRight = null
  document.documentElement.classList.remove('_scroll-lock')
}

function getScrollWidth() {
  return (window.innerWidth - document.documentElement.clientWidth) || parseFloat(getComputedStyle(document.documentElement).paddingRight) || 0
}
